import React, { useEffect, useState } from 'react';
import { Animated, Image, ImageBackground, ImageSourcePropType, PixelRatio, ScrollView, StyleProp, StyleSheet, Text, TouchableOpacity, View, ViewStyle } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useDimensions } from 'react-native-web-hooks';
import { mc } from '../../../game/characters/MC';
import ImageClass from '../../shell/Image';
import useFontSize from '../../shell/hooks/useFontSize';
import { isMobile } from '../../shell/utils/platformCheck';
import { useAppSelector } from '../../store/hooks';
import { selectAdvance, setAdvance, setSeenImage } from '../../store/slices/AdvanceSlice';
import { TimageINT, TquestionFormat, TtalkStateINT } from '../../store/slices/gameObjectSlice';
import { PhoneTypes, selectContacts } from '../../store/slices/phoneSlice';
import { store } from '../../store/store';
import TQuestion from '../TQuestion';
import TTalkContainer from '../TTalkContainer';
import { InstaAvatar } from '../insta/InstaAvatar';
import { useSkippingLogic } from '../useSkippingLogic';
import { Phone } from './PhoneClass';

interface PhoneMessagesProps {
    imageStyle: StyleProp<ViewStyle>,
    phoneStyle: StyleProp<ViewStyle>,
    phoneImage: ImageSourcePropType,
    history2: TtalkStateINT[],
    mainImageStyle?: StyleProp<ViewStyle>;
}

export const PhoneMessages: React.FC<PhoneMessagesProps> = ({ mainImageStyle, imageStyle, phoneStyle, phoneImage, history2 }) => {

    const contactsSlice = useAppSelector(selectContacts);
    const [showHistory, setShowHistory] = useState(false);
    const advanceSlice = useAppSelector(selectAdvance);
    const { width, height } = useDimensions().window;
    const [showImage, setShowImage] = useState<{ image: TimageINT | null, fullscreen: boolean; }>({ image: null, fullscreen: false });

    // const [history, setHistory] = useState<TtalkStateINT[]>([]);
    const scrollViewRef = React.useRef<ScrollView>(null);
    const styles = StyleSheet.create({
        messageStyles: {
            paddingLeft: 0,
            // left: 20 / PixelRatio.get(),
            flex: 1,
            margin: 5 / PixelRatio.get(),
            marginLeft: 20 / PixelRatio.get(),
            marginRight: 20 / PixelRatio.get(),
            textAlign: "left",
            borderRadius: 20 / PixelRatio.get(),
            flexBasis: "auto"
        },
        myComment: {
            bottom: 0,
            backgroundColor: "#269cff",
            alignSelf: "flex-end",
            maxWidth: isMobile() ? "90%" : "55%"
        },
        othersComment: {
            bottom: 0,
            backgroundColor: "#ededed",
            alignSelf: "flex-start",
            padding: 0,
            maxWidth: isMobile() ? "90%" : "55%"

        },
        myCommentText: {
            fontSize: useFontSize(1.4),
            padding: 10 / PixelRatio.get(),
        },
        othersCommentText: {
            color: "black",
            fontSize: useFontSize(1.4),
            textShadowColor: 'rgba(0, 0, 0, 1)',
            textShadowOffset: { width: 0, height: 0 },
            textShadowRadius: 0,
            padding: 10 / PixelRatio.get(),

        } as ViewStyle,
        header: {
            paddingTop: "2%",
            backgroundColor: "whitesmoke",
            height: "10%",
            borderBottomColor: "#e2e2e2b5",
            justifyContent: "center",
            alignItems: "center",
            borderBottomWidth: 1,

        }, headerText: {
            color: "black",
            fontWeight: "bold",
            fontSize: useFontSize(3),
            position: "absolute"
        },
        headerArrow: {
            alignSelf: "flex-start",
            left: "3%",
        },
        mainScreen: {
            backgroundColor: contactsSlice?.selectedContact?.wallpaper ? "transparent" : "white",
            flex: 1,
            // paddingTop: "4%",
            // paddingBottom: "4%",
            height: "100%",

        }, image: {
            paddingRight: 0,
            aspectRatio: 16 / 9,
            width: "100%",
        },
        questionButtonTextStyle: {
            alignItems: "stretch",
            alignSelf: "center",
            color: "white",
            fontWeight: "bold",
            fontSize: useFontSize(1.5),
        }
    });
    useEffect(() => {
        scrollViewRef.current?.scrollToEnd({ animated: false });
        if (useSkippingLogic()) {
            store.dispatch(setAdvance({ canAdvance: true, promise: null }));
        }

    }, [contactsSlice]);
    const onLeftArrowPressed = () => {
    };
    const onImagePressed = (image: TimageINT | null = null) => {
        if (image) {
            store.dispatch(setSeenImage(image));
        }
        setShowImage(showImage => ({ image, fullscreen: !showImage.fullscreen }));
    };
    useEffect(() => {
        setTimeout(() => {
            setShowHistory(true);
            scrollViewRef.current?.scrollToEnd({ animated: false });
        }, 10);
    }, [Phone.finishedHistory]);

    return (
        <>
            <Animated.View style={[mainImageStyle]}>
                <View style={[{ height: "100%", width: "100%", display: "flex", }, imageStyle]}>
                    <View style={styles.header}>
                        {contactsSlice.contacts ? <TouchableOpacity style={styles.headerArrow} onPress={() => onLeftArrowPressed()}>
                            <Icon name={"arrow-left"} size={useFontSize(5 / PixelRatio.get())} style={{ color: "black" }} />
                        </TouchableOpacity> : <></>}
                        <Text selectable={false} style={styles.headerText}>{contactsSlice?.selectedContact?.name}</Text>
                        <View style={{ alignSelf: "flex-end", marginRight: 30 }}>
                            {
                                contactsSlice?.selectedContact?.profileImage ?
                                    <InstaAvatar profilePic={ImageClass._globalImages.get(contactsSlice?.selectedContact?.profileImage.key)?.url as ImageSourcePropType} size={useFontSize(5)}></InstaAvatar> :
                                    <Icon name={"user-circle-o"} size={useFontSize(5 / PixelRatio.get())} style={{ color: "black" }} />

                            }
                        </View>
                    </View>
                    {contactsSlice?.selectedContact?.wallpaper ? <View pointerEvents={"none"} style={{ width: "100%", height: "100%", position: "absolute", zIndex: -2, backgroundColor: "white" }}>
                        <Image style={{ height: "100%", width: "100%", zIndex: -1, backgroundColor: "white" }} resizeMode={"cover"} source={ImageClass._globalImages.get(contactsSlice?.selectedContact?.wallpaper.key)?.url as ImageSourcePropType} />

                    </View> : <></>}
                    <ScrollView contentContainerStyle={{ paddingBottom: 10 / PixelRatio.get() }} ref={scrollViewRef} style={[styles.mainScreen]}>
                        {showHistory && contactsSlice.history?.map((message, index) => {
                            return (
                                <React.Fragment key={message.type + index}>
                                    {message.type === PhoneTypes.MESSAGE ?
                                        <>
                                            <TTalkContainer padding={0} key={(message.content as TtalkStateINT).text + contactsSlice.selectedContact?.name + index}
                                                talkObject={{ ...(message.content as TtalkStateINT), character: { ...(message.content as TtalkStateINT).character, key: (message.content as TtalkStateINT).character?.key!, name: "" } }}
                                                style={[styles.messageStyles, (message.content as TtalkStateINT).character?.name === mc?.character?.name ? styles.myComment : styles.othersComment]}
                                                textStyle={[(message.content as TtalkStateINT).character?.name === mc?.character?.name ? styles.myCommentText : styles.othersCommentText,]}
                                                numberOfLines={9999} />
                                            {/* {index === ((contactsSlice.history?.length || 0) - 1) ?
                                                <TypingAnimation name={contactsSlice?.selectedContact?.name || ''}></TypingAnimation>
                                                : <></>} */}
                                        </>
                                        : <></>}
                                    {message.type === PhoneTypes.IMAGE ?
                                        <TouchableOpacity key={message.type + (message.content as TimageINT).key} onPress={() => onImagePressed((message.content as TimageINT))} style={[, styles.messageStyles, message.content.character?.name === mc?.character?.name ? styles.myComment : styles.othersComment, styles.image]}>
                                            <Image style={{
                                                borderRadius: 9 / PixelRatio.get(),
                                                aspectRatio: 16 / 9
                                            }} resizeMode={"cover"} source={(ImageClass._globalImages.get((message.content as TimageINT).key)?.url) as ImageSourcePropType} />
                                        </TouchableOpacity>
                                        : <></>}


                                </React.Fragment>
                            );
                        })}
                        {/* TODO: move it to a different place because the text dialog is blocking it. */}
                        {contactsSlice?.history?.[contactsSlice?.history?.length - 1].type === PhoneTypes.QUESTION ?
                            <TQuestion buttonsText={styles.questionButtonTextStyle} questionStyle={{}} questionObj={(contactsSlice.history?.[contactsSlice.history.length - 1].content as TquestionFormat)}></TQuestion>
                            : <></>}
                    </ScrollView>

                </View>

                {/* Phone frame */}
                <View pointerEvents={"none"} style={phoneStyle}>
                    <ImageBackground style={[phoneStyle]} source={phoneImage as any} resizeMode={"cover"}></ImageBackground>
                </View>
            </Animated.View>
            {showImage.fullscreen && showImage?.image?.url ?
                <TouchableOpacity onPress={() => onImagePressed()} style={{ width: "100%", height: "100%" }}>
                    <Animated.Image source={showImage?.image?.url as any} style={{ width: "100%", height: "100%" }}></Animated.Image>
                </TouchableOpacity>
                : <></>
            }
        </>
    );
};

// ,{transform:[{rotateZ:"90deg"}]}